// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IStatusDetail
 */
export interface IStatusDetail {
    /**
     * 
     * @type {string}
     * @memberof IStatusDetail
     */
    text?: string;
    /**
     * 
     * @type {Date}
     * @memberof IStatusDetail
     */
    timestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof IStatusDetail
     */
    section_style_type?: IStatusDetailSectionStyleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IStatusDetail
     */
    border_style_type?: IStatusDetailBorderStyleTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IStatusDetailSectionStyleTypeEnum {
    DEFAULT = 'DEFAULT',
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
    WARNING = 'WARNING',
    INFO = 'INFO'
}
/**
* @export
* @enum {string}
*/
export enum IStatusDetailBorderStyleTypeEnum {
    DEFAULT = 'DEFAULT',
    INFO = 'INFO',
    WARN = 'WARN',
    ERROR = 'ERROR'
}


/**
 * Check if a given object implements the IStatusDetail interface.
 */
export function instanceOfIStatusDetail(value: object): value is IStatusDetail {
    return true;
}

export function IStatusDetailFromJSON(json: any): IStatusDetail {
    return IStatusDetailFromJSONTyped(json, false);
}

export function IStatusDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): IStatusDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'] == null ? undefined : json['text'],
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
        'section_style_type': json['section_style_type'] == null ? undefined : json['section_style_type'],
        'border_style_type': json['border_style_type'] == null ? undefined : json['border_style_type'],
    };
}

export function IStatusDetailToJSON(json: any): IStatusDetail {
    return IStatusDetailToJSONTyped(json, false);
}

export function IStatusDetailToJSONTyped(value?: IStatusDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp']).toISOString()),
        'section_style_type': value['section_style_type'],
        'border_style_type': value['border_style_type'],
    };
}

